import { render, staticRenderFns } from "./addEnt.vue?vue&type=template&id=6b4f0c22&"
import script from "./addEnt.vue?vue&type=script&lang=js&"
export * from "./addEnt.vue?vue&type=script&lang=js&"
import style0 from "./addEnt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports